import { notification } from "antd";

const displayErrorNotification = error => {
  if (error instanceof Error) {
    if (error instanceof TypeError) {
      notification.error({
        message: "An error occurred, see console for more information"
      });
      console.error(error.message);
      console.error(error.stack);
      return;
    }
    if (!error.response) {
      notification.error({
        message: `No Response Received. API Server might be down, please try again or else contact na_opsenablement@credera.com.`
      });
      return;
    }
    // to catch validation errors
    if (
      error.response.data.errors !== undefined &&
      error.response.data.errors.length > 0
    ) {
      error.response.data.errors.forEach(e => {
        notification.error({
          duration: 10,
          message: `${error.response.data.status} ${error.response.data.error}`,
          description: e.defaultMessage
        });
      });
    } else {
      // convert to object if responseType is arraybuffer
      var data = error.response.data;
      if (error.config.responseType === "arraybuffer") {
        var decodeString = String.fromCharCode.apply(
          null,
          new Uint8Array(data)
        );
        data = JSON.parse(decodeString);
      }
      notification.error({
        duration: 10,
        message: `${data.status} ${data.error}`,
        description: data.message
      });
    }
  } else if (typeof error === "string") {
    notification.error({
      message: "An Error Occurred",
      description: error
    });
  } else {
    throw Error("Error type not supported");
  }
};

export default displayErrorNotification;
